export const SERVER_URL = "https://api.redirection-ali1-api.me.uk";



// WEBPACK FOOTER //
// ./src/utils/config.js